import { render, staticRenderFns } from "./JobPreferencesForm.vue?vue&type=template&id=38b7703c&scoped=true&"
import script from "./JobPreferencesForm.vue?vue&type=script&lang=ts&"
export * from "./JobPreferencesForm.vue?vue&type=script&lang=ts&"
import style0 from "./JobPreferencesForm.vue?vue&type=style&index=0&id=38b7703c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b7703c",
  null
  
)

export default component.exports